// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Member Directory Styles */
.member-directory {
  padding: 2rem;
  max-width: 1400px;
  margin: 0 auto;
}

.directory-header {
  text-align: center;
  margin-bottom: 2rem;
}

.directory-header h2 {
  color: var(--primary-700, #252A33);
  font-size: 2rem;
  font-weight: 700;
  margin: 0 0 0.5rem 0;
}

.directory-description {
  color: #6b7280;
  font-size: 1.1rem;
  margin: 0;
}

/* Filters */
.directory-filters {
  background: white;
  border-radius: 12px;
  padding: 1.5rem;
  margin-bottom: 2rem;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  border: 1px solid #e5e7eb;
}

.filters-form {
  display: grid;
  grid-template-columns: 2fr 1fr 1fr auto;
  gap: 1rem;
  align-items: end;
}

.filter-group {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.filter-group label {
  font-weight: 600;
  color: #374151;
  font-size: 0.9rem;
}

.filter-group input,
.filter-group select {
  padding: 0.75rem;
  border: 1px solid #d1d5db;
  border-radius: 8px;
  font-size: 0.9rem;
  transition: border-color 0.3s ease;
}

.filter-group input:focus,
.filter-group select:focus {
  outline: none;
  border-color: var(--primary-500, #3b82f6);
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
}

.filter-actions {
  display: flex;
  gap: 0.5rem;
}

.search-btn,
.clear-btn {
  padding: 0.75rem 1.5rem;
  border: none;
  border-radius: 8px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  font-size: 0.9rem;
}

.search-btn {
  background: var(--primary-600, #EA580C);
  color: white;
}

.search-btn:hover {
  background: var(--primary-700, #1d4ed8);
  transform: translateY(-1px);
}

.clear-btn {
  background: #6b7280;
  color: white;
}

.clear-btn:hover {
  background: #4b5563;
  transform: translateY(-1px);
}

/* Results Summary */
.results-summary {
  margin-bottom: 1.5rem;
  padding: 0 0.5rem;
}

.results-summary p {
  color: #6b7280;
  font-size: 0.9rem;
  margin: 0;
}

/* Members Table */
.members-table-container {
  background: white;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  border: 1px solid #e5e7eb;
  overflow: hidden;
  margin-bottom: 2rem;
}

.table-wrapper {
  overflow-x: auto;
}

.members-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 0.9rem;
}

.members-table thead {
  background: #252A33;
  color: white;
}

.members-table th {
  padding: 1rem 0.75rem;
  text-align: left;
  font-weight: 600;
  font-size: 0.85rem;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  border-bottom: 2px solid var(--primary-800, #1e3a8a);
}

.members-table tbody tr {
  border-bottom: 1px solid #e5e7eb;
  transition: background-color 0.2s ease;
}

.members-table tbody tr:hover {
  background-color: #F7F7F8;
}

.members-table tbody tr:last-child {
  border-bottom: none;
}

.members-table td {
  padding: 1rem 0.75rem;
  vertical-align: top;
}

/* Organization Cell */
.organization-cell {
  min-width: 250px;
}

.organization-info {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.organization-name {
  font-weight: 600;
  color: var(--primary-700, #252A33);
  font-size: 1rem;
  line-height: 1.3;
}

.organization-notes {
  font-size: 0.8rem;
  color: #6b7280;
  font-style: italic;
  line-height: 1.4;
}

.organization-website {
  margin-top: 0.25rem;
}

.website-link {
  color: var(--primary-600, #EA580C);
  text-decoration: none;
  font-size: 0.8rem;
  font-weight: 500;
}

.website-link:hover {
  text-decoration: underline;
}

/* Member ID Cell */
.member-id-cell {
  min-width: 120px;
}

.member-id-badge {
  background: #f1f5f9;
  color: #475569;
  padding: 0.25rem 0.5rem;
  border-radius: 6px;
  font-family: 'Courier New', monospace;
  font-size: 0.8rem;
  font-weight: 600;
  border: 1px solid #e2e8f0;
}

/* Contact Cell */
.contact-cell {
  min-width: 200px;
}

.contact-info {
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
}

.contact-name {
  font-weight: 600;
  color: #374151;
  font-size: 0.9rem;
}

.contact-email a {
  color: var(--primary-600, #EA580C);
  text-decoration: none;
  font-size: 0.85rem;
  word-break: break-all;
}

.contact-email a:hover {
  text-decoration: underline;
}

.contact-phone {
  color: #6b7280;
  font-size: 0.8rem;
}

/* Location Cell */
.location-cell {
  min-width: 150px;
}

.location-info {
  display: flex;
  flex-direction: column;
  gap: 0.1rem;
}

.location-city {
  font-weight: 600;
  color: #374151;
  font-size: 0.9rem;
}

.location-state {
  color: #6b7280;
  font-size: 0.8rem;
  font-weight: 500;
}

.location-country {
  color: #9ca3af;
  font-size: 0.75rem;
}

/* Membership Status Cell */
.membership-status-cell {
  min-width: 120px;
}

.membership-status-badge {
  display: inline-block;
  padding: 0.4rem 0.8rem;
  border-radius: 20px;
  font-size: 0.8rem;
  font-weight: 600;
  text-transform: capitalize;
  text-align: center;
  min-width: 80px;
  border: 1px solid transparent;
}

.membership-status-badge.status-active {
  background: #dcfce7;
  color: #166534;
  border-color: #bbf7d0;
}

.membership-status-badge.status-terminated {
  background: #fee2e2;
  color: #991b1b;
  border-color: #fecaca;
}

.membership-status-badge.status-suspended {
  background: #fef3c7;
  color: #92400e;
  border-color: #fde68a;
}

.membership-status-badge.status-pending {
  background: #e0e7ff;
  color: #3730a3;
  border-color: #c7d2fe;
}

.membership-status-badge.status-unknown {
  background: #f3f4f6;
  color: #6b7280;
  border-color: #e5e7eb;
}

/* Active Status Cell */
.active-status-cell {
  min-width: 100px;
}

.active-status-badge {
  display: inline-block;
  padding: 0.4rem 0.8rem;
  border-radius: 20px;
  font-size: 0.8rem;
  font-weight: 600;
  text-align: center;
  min-width: 70px;
  border: 1px solid transparent;
}

.active-status-badge.active {
  background: #dcfce7;
  color: #166534;
  border-color: #bbf7d0;
}

.active-status-badge.inactive {
  background: #fee2e2;
  color: #991b1b;
  border-color: #fecaca;
}

/* Date Cell */
.date-cell {
  min-width: 120px;
}

.member-date {
  color: #6b7280;
  font-size: 0.85rem;
  font-weight: 500;
}


/* No Results */
.no-results {
  grid-column: 1 / -1;
  text-align: center;
  padding: 3rem;
  color: #6b7280;
}

.no-results-icon {
  font-size: 3rem;
  margin-bottom: 1rem;
}

.no-results h3 {
  color: #374151;
  font-size: 1.5rem;
  margin: 0 0 0.5rem 0;
}

.no-results p {
  margin: 0;
  font-size: 1rem;
}

/* Pagination */
.pagination {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 1rem;
  margin-top: 2rem;
}

.pagination-btn {
  padding: 0.75rem 1.5rem;
  border: 1px solid #d1d5db;
  border-radius: 8px;
  background: white;
  color: #374151;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
}

.pagination-btn:hover:not(:disabled) {
  background: var(--primary-50, #eff6ff);
  border-color: var(--primary-300, #FDBA74);
  color: var(--primary-700, #252A33);
}

.pagination-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.pagination-info {
  color: #6b7280;
  font-size: 0.9rem;
}

/* Loading State */
.loading-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 3rem;
  color: #6b7280;
}

.loading-container p {
  margin-top: 1rem;
  font-size: 1rem;
}

/* Responsive Design */
@media (max-width: 1024px) {
  .member-directory {
    padding: 1rem;
  }

  .members-table {
    font-size: 0.85rem;
  }

  .members-table th,
  .members-table td {
    padding: 0.75rem 0.5rem;
  }

  .organization-cell {
    min-width: 220px;
  }

  .contact-cell {
    min-width: 180px;
  }

  .location-cell {
    min-width: 130px;
  }

  .membership-status-cell {
    min-width: 100px;
  }

  .active-status-cell {
    min-width: 90px;
  }
}

@media (max-width: 768px) {
  .member-directory {
    padding: 0.5rem;
  }

  .filters-form {
    grid-template-columns: 1fr;
    gap: 1rem;
  }

  .filter-actions {
    justify-content: stretch;
  }

  .search-btn,
  .clear-btn {
    flex: 1 1;
  }

  .members-table-container {
    border-radius: 8px;
    margin: 0 -0.5rem;
  }

  .table-wrapper {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }

  .members-table {
    font-size: 0.8rem;
    min-width: 900px;
  }

  .members-table th,
  .members-table td {
    padding: 0.75rem 0.5rem;
  }

  .organization-cell {
    min-width: 200px;
  }

  .contact-cell {
    min-width: 150px;
  }

  .location-cell {
    min-width: 120px;
  }

  .membership-status-cell {
    min-width: 100px;
  }

  .active-status-cell {
    min-width: 80px;
  }

  .membership-status-badge,
  .active-status-badge {
    font-size: 0.7rem;
    padding: 0.3rem 0.6rem;
    min-width: 60px;
  }

  .pagination {
    flex-direction: column;
    gap: 0.5rem;
  }
}

@media (max-width: 480px) {
  .member-directory {
    padding: 0.25rem;
  }

  .directory-header h2 {
    font-size: 1.5rem;
  }

  .directory-description {
    font-size: 1rem;
  }

  .filters-form {
    gap: 0.75rem;
  }

  .filter-group input,
  .filter-group select {
    padding: 0.5rem;
    font-size: 0.85rem;
  }

  .search-btn,
  .clear-btn {
    padding: 0.5rem 1rem;
    font-size: 0.85rem;
  }

  .members-table-container {
    margin: 0 -0.25rem;
    border-radius: 6px;
  }

  .members-table {
    font-size: 0.75rem;
    min-width: 800px;
  }

  .members-table th {
    font-size: 0.7rem;
    padding: 0.5rem 0.25rem;
  }

  .members-table td {
    padding: 0.5rem 0.25rem;
  }

  .organization-name {
    font-size: 0.85rem;
  }

  .contact-name {
    font-size: 0.75rem;
  }

  .contact-email a {
    font-size: 0.7rem;
  }

  .location-city {
    font-size: 0.75rem;
  }

  .member-id-badge {
    font-size: 0.65rem;
    padding: 0.15rem 0.3rem;
  }

  .membership-status-badge,
  .active-status-badge {
    font-size: 0.65rem;
    padding: 0.25rem 0.5rem;
    min-width: 50px;
  }

  .member-date {
    font-size: 0.75rem;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/members/MemberDirectory.css"],"names":[],"mappings":"AAAA,4BAA4B;AAC5B;EACE,aAAa;EACb,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,kCAAkC;EAClC,eAAe;EACf,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,SAAS;AACX;;AAEA,YAAY;AACZ;EACE,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,mBAAmB;EACnB,wCAAwC;EACxC,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,uCAAuC;EACvC,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,iBAAiB;AACnB;;AAEA;;EAEE,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,kCAAkC;AACpC;;AAEA;;EAEE,aAAa;EACb,yCAAyC;EACzC,6CAA6C;AAC/C;;AAEA;EACE,aAAa;EACb,WAAW;AACb;;AAEA;;EAEE,uBAAuB;EACvB,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,uCAAuC;EACvC,YAAY;AACd;;AAEA;EACE,uCAAuC;EACvC,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA,oBAAoB;AACpB;EACE,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,SAAS;AACX;;AAEA,kBAAkB;AAClB;EACE,iBAAiB;EACjB,mBAAmB;EACnB,wCAAwC;EACxC,yBAAyB;EACzB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;EACzB,sBAAsB;EACtB,oDAAoD;AACtD;;AAEA;EACE,gCAAgC;EAChC,sCAAsC;AACxC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA,sBAAsB;AACtB;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,kCAAkC;EAClC,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kCAAkC;EAClC,qBAAqB;EACrB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA,mBAAmB;AACnB;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,uBAAuB;EACvB,kBAAkB;EAClB,qCAAqC;EACrC,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA,iBAAiB;AACjB;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,kCAAkC;EAClC,qBAAqB;EACrB,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA,kBAAkB;AAClB;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA,2BAA2B;AAC3B;EACE,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,sBAAsB;EACtB,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,0BAA0B;EAC1B,kBAAkB;EAClB,eAAe;EACf,6BAA6B;AAC/B;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,qBAAqB;AACvB;;AAEA,uBAAuB;AACvB;EACE,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,sBAAsB;EACtB,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,6BAA6B;AAC/B;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,qBAAqB;AACvB;;AAEA,cAAc;AACd;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;;;AAGA,eAAe;AACf;EACE,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,SAAS;EACT,eAAe;AACjB;;AAEA,eAAe;AACf;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;EACvB,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,sCAAsC;EACtC,yCAAyC;EACzC,kCAAkC;AACpC;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA,sBAAsB;AACtB;EACE;IACE,aAAa;EACf;;EAEA;IACE,kBAAkB;EACpB;;EAEA;;IAEE,uBAAuB;EACzB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,0BAA0B;IAC1B,SAAS;EACX;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;;IAEE,SAAO;EACT;;EAEA;IACE,kBAAkB;IAClB,iBAAiB;EACnB;;EAEA;IACE,gBAAgB;IAChB,iCAAiC;EACnC;;EAEA;IACE,iBAAiB;IACjB,gBAAgB;EAClB;;EAEA;;IAEE,uBAAuB;EACzB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,eAAe;EACjB;;EAEA;;IAEE,iBAAiB;IACjB,sBAAsB;IACtB,eAAe;EACjB;;EAEA;IACE,sBAAsB;IACtB,WAAW;EACb;AACF;;AAEA;EACE;IACE,gBAAgB;EAClB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,YAAY;EACd;;EAEA;;IAEE,eAAe;IACf,kBAAkB;EACpB;;EAEA;;IAEE,oBAAoB;IACpB,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;IAClB,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;IAClB,gBAAgB;EAClB;;EAEA;IACE,iBAAiB;IACjB,uBAAuB;EACzB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;IAClB,uBAAuB;EACzB;;EAEA;;IAEE,kBAAkB;IAClB,uBAAuB;IACvB,eAAe;EACjB;;EAEA;IACE,kBAAkB;EACpB;AACF","sourcesContent":["/* Member Directory Styles */\n.member-directory {\n  padding: 2rem;\n  max-width: 1400px;\n  margin: 0 auto;\n}\n\n.directory-header {\n  text-align: center;\n  margin-bottom: 2rem;\n}\n\n.directory-header h2 {\n  color: var(--primary-700, #252A33);\n  font-size: 2rem;\n  font-weight: 700;\n  margin: 0 0 0.5rem 0;\n}\n\n.directory-description {\n  color: #6b7280;\n  font-size: 1.1rem;\n  margin: 0;\n}\n\n/* Filters */\n.directory-filters {\n  background: white;\n  border-radius: 12px;\n  padding: 1.5rem;\n  margin-bottom: 2rem;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n  border: 1px solid #e5e7eb;\n}\n\n.filters-form {\n  display: grid;\n  grid-template-columns: 2fr 1fr 1fr auto;\n  gap: 1rem;\n  align-items: end;\n}\n\n.filter-group {\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n}\n\n.filter-group label {\n  font-weight: 600;\n  color: #374151;\n  font-size: 0.9rem;\n}\n\n.filter-group input,\n.filter-group select {\n  padding: 0.75rem;\n  border: 1px solid #d1d5db;\n  border-radius: 8px;\n  font-size: 0.9rem;\n  transition: border-color 0.3s ease;\n}\n\n.filter-group input:focus,\n.filter-group select:focus {\n  outline: none;\n  border-color: var(--primary-500, #3b82f6);\n  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);\n}\n\n.filter-actions {\n  display: flex;\n  gap: 0.5rem;\n}\n\n.search-btn,\n.clear-btn {\n  padding: 0.75rem 1.5rem;\n  border: none;\n  border-radius: 8px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  font-size: 0.9rem;\n}\n\n.search-btn {\n  background: var(--primary-600, #EA580C);\n  color: white;\n}\n\n.search-btn:hover {\n  background: var(--primary-700, #1d4ed8);\n  transform: translateY(-1px);\n}\n\n.clear-btn {\n  background: #6b7280;\n  color: white;\n}\n\n.clear-btn:hover {\n  background: #4b5563;\n  transform: translateY(-1px);\n}\n\n/* Results Summary */\n.results-summary {\n  margin-bottom: 1.5rem;\n  padding: 0 0.5rem;\n}\n\n.results-summary p {\n  color: #6b7280;\n  font-size: 0.9rem;\n  margin: 0;\n}\n\n/* Members Table */\n.members-table-container {\n  background: white;\n  border-radius: 12px;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n  border: 1px solid #e5e7eb;\n  overflow: hidden;\n  margin-bottom: 2rem;\n}\n\n.table-wrapper {\n  overflow-x: auto;\n}\n\n.members-table {\n  width: 100%;\n  border-collapse: collapse;\n  font-size: 0.9rem;\n}\n\n.members-table thead {\n  background: #252A33;\n  color: white;\n}\n\n.members-table th {\n  padding: 1rem 0.75rem;\n  text-align: left;\n  font-weight: 600;\n  font-size: 0.85rem;\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n  border-bottom: 2px solid var(--primary-800, #1e3a8a);\n}\n\n.members-table tbody tr {\n  border-bottom: 1px solid #e5e7eb;\n  transition: background-color 0.2s ease;\n}\n\n.members-table tbody tr:hover {\n  background-color: #F7F7F8;\n}\n\n.members-table tbody tr:last-child {\n  border-bottom: none;\n}\n\n.members-table td {\n  padding: 1rem 0.75rem;\n  vertical-align: top;\n}\n\n/* Organization Cell */\n.organization-cell {\n  min-width: 250px;\n}\n\n.organization-info {\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n}\n\n.organization-name {\n  font-weight: 600;\n  color: var(--primary-700, #252A33);\n  font-size: 1rem;\n  line-height: 1.3;\n}\n\n.organization-notes {\n  font-size: 0.8rem;\n  color: #6b7280;\n  font-style: italic;\n  line-height: 1.4;\n}\n\n.organization-website {\n  margin-top: 0.25rem;\n}\n\n.website-link {\n  color: var(--primary-600, #EA580C);\n  text-decoration: none;\n  font-size: 0.8rem;\n  font-weight: 500;\n}\n\n.website-link:hover {\n  text-decoration: underline;\n}\n\n/* Member ID Cell */\n.member-id-cell {\n  min-width: 120px;\n}\n\n.member-id-badge {\n  background: #f1f5f9;\n  color: #475569;\n  padding: 0.25rem 0.5rem;\n  border-radius: 6px;\n  font-family: 'Courier New', monospace;\n  font-size: 0.8rem;\n  font-weight: 600;\n  border: 1px solid #e2e8f0;\n}\n\n/* Contact Cell */\n.contact-cell {\n  min-width: 200px;\n}\n\n.contact-info {\n  display: flex;\n  flex-direction: column;\n  gap: 0.25rem;\n}\n\n.contact-name {\n  font-weight: 600;\n  color: #374151;\n  font-size: 0.9rem;\n}\n\n.contact-email a {\n  color: var(--primary-600, #EA580C);\n  text-decoration: none;\n  font-size: 0.85rem;\n  word-break: break-all;\n}\n\n.contact-email a:hover {\n  text-decoration: underline;\n}\n\n.contact-phone {\n  color: #6b7280;\n  font-size: 0.8rem;\n}\n\n/* Location Cell */\n.location-cell {\n  min-width: 150px;\n}\n\n.location-info {\n  display: flex;\n  flex-direction: column;\n  gap: 0.1rem;\n}\n\n.location-city {\n  font-weight: 600;\n  color: #374151;\n  font-size: 0.9rem;\n}\n\n.location-state {\n  color: #6b7280;\n  font-size: 0.8rem;\n  font-weight: 500;\n}\n\n.location-country {\n  color: #9ca3af;\n  font-size: 0.75rem;\n}\n\n/* Membership Status Cell */\n.membership-status-cell {\n  min-width: 120px;\n}\n\n.membership-status-badge {\n  display: inline-block;\n  padding: 0.4rem 0.8rem;\n  border-radius: 20px;\n  font-size: 0.8rem;\n  font-weight: 600;\n  text-transform: capitalize;\n  text-align: center;\n  min-width: 80px;\n  border: 1px solid transparent;\n}\n\n.membership-status-badge.status-active {\n  background: #dcfce7;\n  color: #166534;\n  border-color: #bbf7d0;\n}\n\n.membership-status-badge.status-terminated {\n  background: #fee2e2;\n  color: #991b1b;\n  border-color: #fecaca;\n}\n\n.membership-status-badge.status-suspended {\n  background: #fef3c7;\n  color: #92400e;\n  border-color: #fde68a;\n}\n\n.membership-status-badge.status-pending {\n  background: #e0e7ff;\n  color: #3730a3;\n  border-color: #c7d2fe;\n}\n\n.membership-status-badge.status-unknown {\n  background: #f3f4f6;\n  color: #6b7280;\n  border-color: #e5e7eb;\n}\n\n/* Active Status Cell */\n.active-status-cell {\n  min-width: 100px;\n}\n\n.active-status-badge {\n  display: inline-block;\n  padding: 0.4rem 0.8rem;\n  border-radius: 20px;\n  font-size: 0.8rem;\n  font-weight: 600;\n  text-align: center;\n  min-width: 70px;\n  border: 1px solid transparent;\n}\n\n.active-status-badge.active {\n  background: #dcfce7;\n  color: #166534;\n  border-color: #bbf7d0;\n}\n\n.active-status-badge.inactive {\n  background: #fee2e2;\n  color: #991b1b;\n  border-color: #fecaca;\n}\n\n/* Date Cell */\n.date-cell {\n  min-width: 120px;\n}\n\n.member-date {\n  color: #6b7280;\n  font-size: 0.85rem;\n  font-weight: 500;\n}\n\n\n/* No Results */\n.no-results {\n  grid-column: 1 / -1;\n  text-align: center;\n  padding: 3rem;\n  color: #6b7280;\n}\n\n.no-results-icon {\n  font-size: 3rem;\n  margin-bottom: 1rem;\n}\n\n.no-results h3 {\n  color: #374151;\n  font-size: 1.5rem;\n  margin: 0 0 0.5rem 0;\n}\n\n.no-results p {\n  margin: 0;\n  font-size: 1rem;\n}\n\n/* Pagination */\n.pagination {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  gap: 1rem;\n  margin-top: 2rem;\n}\n\n.pagination-btn {\n  padding: 0.75rem 1.5rem;\n  border: 1px solid #d1d5db;\n  border-radius: 8px;\n  background: white;\n  color: #374151;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.3s ease;\n}\n\n.pagination-btn:hover:not(:disabled) {\n  background: var(--primary-50, #eff6ff);\n  border-color: var(--primary-300, #FDBA74);\n  color: var(--primary-700, #252A33);\n}\n\n.pagination-btn:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.pagination-info {\n  color: #6b7280;\n  font-size: 0.9rem;\n}\n\n/* Loading State */\n.loading-container {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 3rem;\n  color: #6b7280;\n}\n\n.loading-container p {\n  margin-top: 1rem;\n  font-size: 1rem;\n}\n\n/* Responsive Design */\n@media (max-width: 1024px) {\n  .member-directory {\n    padding: 1rem;\n  }\n\n  .members-table {\n    font-size: 0.85rem;\n  }\n\n  .members-table th,\n  .members-table td {\n    padding: 0.75rem 0.5rem;\n  }\n\n  .organization-cell {\n    min-width: 220px;\n  }\n\n  .contact-cell {\n    min-width: 180px;\n  }\n\n  .location-cell {\n    min-width: 130px;\n  }\n\n  .membership-status-cell {\n    min-width: 100px;\n  }\n\n  .active-status-cell {\n    min-width: 90px;\n  }\n}\n\n@media (max-width: 768px) {\n  .member-directory {\n    padding: 0.5rem;\n  }\n\n  .filters-form {\n    grid-template-columns: 1fr;\n    gap: 1rem;\n  }\n\n  .filter-actions {\n    justify-content: stretch;\n  }\n\n  .search-btn,\n  .clear-btn {\n    flex: 1;\n  }\n\n  .members-table-container {\n    border-radius: 8px;\n    margin: 0 -0.5rem;\n  }\n\n  .table-wrapper {\n    overflow-x: auto;\n    -webkit-overflow-scrolling: touch;\n  }\n\n  .members-table {\n    font-size: 0.8rem;\n    min-width: 900px;\n  }\n\n  .members-table th,\n  .members-table td {\n    padding: 0.75rem 0.5rem;\n  }\n\n  .organization-cell {\n    min-width: 200px;\n  }\n\n  .contact-cell {\n    min-width: 150px;\n  }\n\n  .location-cell {\n    min-width: 120px;\n  }\n\n  .membership-status-cell {\n    min-width: 100px;\n  }\n\n  .active-status-cell {\n    min-width: 80px;\n  }\n\n  .membership-status-badge,\n  .active-status-badge {\n    font-size: 0.7rem;\n    padding: 0.3rem 0.6rem;\n    min-width: 60px;\n  }\n\n  .pagination {\n    flex-direction: column;\n    gap: 0.5rem;\n  }\n}\n\n@media (max-width: 480px) {\n  .member-directory {\n    padding: 0.25rem;\n  }\n\n  .directory-header h2 {\n    font-size: 1.5rem;\n  }\n\n  .directory-description {\n    font-size: 1rem;\n  }\n\n  .filters-form {\n    gap: 0.75rem;\n  }\n\n  .filter-group input,\n  .filter-group select {\n    padding: 0.5rem;\n    font-size: 0.85rem;\n  }\n\n  .search-btn,\n  .clear-btn {\n    padding: 0.5rem 1rem;\n    font-size: 0.85rem;\n  }\n\n  .members-table-container {\n    margin: 0 -0.25rem;\n    border-radius: 6px;\n  }\n\n  .members-table {\n    font-size: 0.75rem;\n    min-width: 800px;\n  }\n\n  .members-table th {\n    font-size: 0.7rem;\n    padding: 0.5rem 0.25rem;\n  }\n\n  .members-table td {\n    padding: 0.5rem 0.25rem;\n  }\n\n  .organization-name {\n    font-size: 0.85rem;\n  }\n\n  .contact-name {\n    font-size: 0.75rem;\n  }\n\n  .contact-email a {\n    font-size: 0.7rem;\n  }\n\n  .location-city {\n    font-size: 0.75rem;\n  }\n\n  .member-id-badge {\n    font-size: 0.65rem;\n    padding: 0.15rem 0.3rem;\n  }\n\n  .membership-status-badge,\n  .active-status-badge {\n    font-size: 0.65rem;\n    padding: 0.25rem 0.5rem;\n    min-width: 50px;\n  }\n\n  .member-date {\n    font-size: 0.75rem;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
